import cx from "classnames";
import { FC, SVGProps } from "react";

import { Icon } from "atoms/icon/Icon";
import ChevronRight from "atoms/icon/icons/ic_chevron_right_small_ol.svg";

export interface SettingsContainerButtonProps {
  children: string;
  disabled?: boolean;
  startIconSVG?: FC<SVGProps<SVGSVGElement>>;
  onClick?: () => void;
}

export const SettingsContainerButton = ({
  children,
  disabled = false,
  startIconSVG: Svg,
  onClick,
}: SettingsContainerButtonProps) => {
  return (
    <div className={cx({ "opacity-40": disabled })}>
      <button
        onClick={onClick}
        disabled={disabled}
        className="flex w-full items-center gap-4 bg-white p-4 text-left text-body1 text-primary"
      >
        {Svg && <Svg className="h-6 w-6 fill-[theme(textColor.secondary)]" />}
        <div className="flex-1">
          {children.charAt(0).toUpperCase() + children.slice(1).toLowerCase()}
        </div>
        <div>
          <Icon svg={ChevronRight} color="brandColor" size="xsmall" />
        </div>
      </button>
    </div>
  );
};
